<template>
  <div class="page-box">
    <el-form inline size="medium" :model="searchForm">
      <el-form-item label="所属国家">
        <el-select v-model="searchForm.countryId" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="item in countryList"
            :key="item.id"
            :label="item.namec"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="仓库">
        <el-input
          v-model="searchForm.warehouseName"
          placeholder="请输入仓库名，支持模糊搜索"
        ></el-input>
      </el-form-item>
      <el-form-item label="供应商类别">
        <el-select
          v-model="searchForm.supplierType"
          clearable
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="专线" :value="1"></el-option>
          <el-option label="尾程分段" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-button icon="el-icon-search" @click="getPage">查询</el-button>
        <el-button type="primary" @click="addNew">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      :header-cell-style="{ background: '#F3F3F3' }"
      max-height="700px"
    >
      <el-table-column label="序号" type="index" align="center" width="50"></el-table-column>
      <el-table-column label="所属国家" prop="countryName" align="center" width=""></el-table-column>
      <el-table-column label="供应商类别" prop="supplierType" align="center" :formatter="supplierTypeFormatter" width=""></el-table-column>
      <el-table-column label="仓库名称" prop="warehouseName" align="center" width=""></el-table-column>
      <el-table-column label="仓库别名" prop="warehouseAlias" align="center" width="" :formatter="(row) => row.warehouseAlias || '/'"></el-table-column>
      <el-table-column label="仓库地址" prop="warehouseAddress" align="center" width=""></el-table-column>
      <el-table-column label="相对地址" prop="relativeAddress" align="center" width=""></el-table-column>
      <el-table-column label="联系人" prop="contactPerson" align="center" width=""></el-table-column>
      <el-table-column label="联系电话" prop="contactPhone" align="center" width=""></el-table-column>
      <el-table-column label="操作" align="center" width="">
        <template slot-scope="scope">
          <el-link type="primary"
                     :underline="false"
                     @click="viewDetails(scope.row.id)"
                     style="margin-left: 6px;">查看</el-link>
          <el-link type="warning"
                     :underline="false"
                     @click="handleEdit(scope.row.id)"
                     style="margin-left: 6px;">修改</el-link>
          <el-link type="danger"
                     :underline="false"
                     @click="handleDelete(scope.row.id,scope.row.state)"
                     style="margin-left: 6px;">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="paging-row"
                   background
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :current-page="page.pageNum"
                   :page-sizes="[5,10,15, 20]"
                   :page-size="page.pageSize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="totalListNum">
    </el-pagination>

    <el-dialog
      :visible.sync="dialogState"
      :title="dialogTitle"
      width="700px"
      @close="dialogClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        inline
        size="mini"
        label-width="100px"
        ref="ruleForm"
        class="ruleForm">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="供应商类别" prop="supplierType">
              <el-select
                v-model="ruleForm.supplierType"
                placeholder="请输入"
                :disabled="dialogType === 3">
                <el-option label="专线" :value="1"></el-option>
                <el-option label="尾程分段" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="仓库名称" prop="warehouseName">
              <el-input
                v-model="ruleForm.warehouseName"
                placeholder="请输入"
                :readonly="dialogType === 3">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="仓库别名" prop="warehouseAlias">
              <el-input
                v-model="ruleForm.warehouseAlias"
                placeholder="请输入"
                :readonly="dialogType === 3">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="仓库代码" prop="warehouseCode">
              <el-input
                v-model="ruleForm.warehouseCode"
                placeholder="请输入"
                :readonly="dialogType === 3">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系人" prop="contactPerson">
              <el-input
                v-model="ruleForm.contactPerson"
                placeholder="请输入"
                :readonly="dialogType === 3">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="contactPhone">
              <el-input
                v-model="ruleForm.contactPhone"
                placeholder="请输入"
                :readonly="dialogType === 3">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="所属地" prop="contactPerson">
              <el-cascader
                filterable
                v-model="ruleForm.belong"
                :options="countryList"
                :props="{ label: 'namec' }"
                :disabled="dialogType === 3">
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮编" prop="postCode">
              <el-input
                v-model="ruleForm.postCode"
                placeholder="请输入"
                :readonly="dialogType === 3">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="仓库地址" prop="warehouseAddress">
              <el-input
                v-model="ruleForm.warehouseAddress"
                type="textarea"
                :rows="4"
                placeholder="请输入"
                style="width: 500px;"
                :readonly="dialogType === 3">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item prop="relativeAddress">
              <span slot="label">
                <span>相对地址</span>
                <el-tooltip
                  effect="dark"
                  trigger="hover"
                  placement="top-start"
                  content="此地址用于试算派送距离时，不暴露仓库真实地址，例：xxxx城市名称/xxxx海港名称">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </span>
              <el-input
                v-model="ruleForm.relativeAddress"
                placeholder="请输入"
                style="width: 500px;"
                :readonly="dialogType === 3">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="自定义标签">
              <el-input v-model="ruleForm.label1"
                size="small"
                placeholder="请输入"
                maxlength="20"
                show-word-limit
                style="margin-right: 15px; width: 110px"></el-input>
              <el-input v-model="ruleForm.label2"
                size="small"
                placeholder="请输入"
                maxlength="20"
                show-word-limit
                style="margin-right: 15px; width: 110px"></el-input>
              <el-input v-model="ruleForm.label3"
                size="small"
                placeholder="请输入"
                maxlength="20"
                show-word-limit
                style="margin-right: 15px; width: 110px"></el-input>
              <el-input v-model="ruleForm.label4"
                size="small"
                placeholder="请输入"
                maxlength="20"
                show-word-limit
                style="width: 110px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button @click="dialogClose">取消</el-button>
        <el-button v-if="dialogType !== 3" type="primary" @click="handleSave(dialogType)">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import qs from 'qs'
export default {
  data() {
    return {
      countryList: [],
      searchForm: {
        countryId: '',
        warehouseName: '',
        supplierType: ''
      },
      page: {
        pageNum: 1,
        pageSize: 10
      },
      totalListNum: 0,
      tableData: [],
      dialogState: false,
      dialogTitle: '新增',
      dialogType: 1,
      ruleForm: {
        contactPerson: '',
        contactPhone: '',
        id: '',
        postCode: '',
        provinceId: '',
        relativeAddress: '',
        supplierId: '',
        warehouseAddress: '',
        warehouseCode: '',
        warehouseName: '',
        warehouseAlias: '',
        supplierType: '',
        belong: [],
        label1: '',
        label2: '',
        label3: '',
        label4: ''
      },
      rules: {
        supplierType: [
          { required: true, message: '请选择供应商类别', trigger: 'blur' }
        ],
        warehouseName: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        warehouseAlias: [
          { required: true, message: '请填写仓库别名', trigger: 'blur' }
        ],
        warehouseCode: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        contactPerson: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        warehouseCode: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        warehouseAddress: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        relativeAddress: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        postCode: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
      }
    }
  },
  methods: {
    supplierTypeFormatter(row) {
      if (row.supplierType == '1') return '专线'
      else if (row.supplierType == '2') return '尾程分段'
      else row.supplierType || '/'
    },
    /**
     * 获取 目的国家/仓库
     */
    getCountryList() {
      return new Promise((resolve, reject) => {
        this.axios.get('/warehouse/getFBAWarehouseList', {})
          .then(res => {
            if (res.data.code !== 200) {
              return false;
            }
            res.data.datas.forEach(res=>{
              if(res.children) res.children.unshift({namec:'全部',id:""});
            });
            res.data.datas.unshift({namec:'全部',id:""});
            this.countryList = res.data.datas;
            resolve(res);
          })
          .catch((res) => {
          });
      });
    },
    getPage() {
      let params = Object.assign(this.searchForm, this.page)
      params.supplierId = JSON.parse(localStorage.getItem("Authorization_lineSupplier")).customerid;
      this.axios.post('/supplierBaseOverseasWarehouse/page', params).then(res => {
        this.tableData = res.data.data.records
        this.totalListNum = res.data.data.total;
      })
    },
    addNew() {
      this.dialogTitle = '新增'
      this.dialogType = 1
      this.dialogState = true
    },
    /**
     * @description: 新增与修改
     * @param {*} type 1：新增，2：保存
     * @return {*}
     */
    handleSave(type) {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const params = JSON.parse(JSON.stringify(this.ruleForm))
          params.countryId = params.belong[0]
          params.provinceId = params.belong[1]
          params.cityId = params.belong[2]
          delete params.belong
          params.supplierId = JSON.parse(localStorage.getItem("Authorization_lineSupplier")).customerid
          let url
          if (type === 1) {
            url = '/supplierBaseOverseasWarehouse/add'
          } else {
            url = '/supplierBaseOverseasWarehouse/edit'
          }
          this.axios.post(url, params)
            .then(res => {
              if (res.data.code === 200) {
                this.dialogClose()
                this.getPage()
                this.$message.success('成功')
              } else {
                this.$message.error(res.data.message)
              }
            })
        }
      })
    },
    getCountryList() {
      this.axios.post('/filedata/findThirdLevelAddress')
        .then(res => {
          this.countryList = res.data.datas
        })
    },
    viewDetails(id) {
      return new Promise((resolve, reject) => {
        this.axios
          .get(`/supplierBaseOverseasWarehouse/detail/${id}`)
          .then(res => {
            if (res.data.code === 200) {
              const data = res.data.data
              Object.keys(this.ruleForm).forEach(key => {
                this.ruleForm[key] = data[key]
              })
              const arr = []
              arr[0] = data.countryId
              arr[1] = data.provinceId
              arr[2] = data.cityId
              this.ruleForm.belong = arr
              resolve(this.ruleForm)
              this.dialogType = 3
              this.dialogTitle = '详情'
              this.dialogState = true
            } else {
              reject(res.data.message)
            }
          })
      })
    },
    dialogClose() {
      Object.keys(this.ruleForm).forEach(key => {
        this.ruleForm[key] = null
      })
      this.dialogState = false
    },
    handleEdit(id) {
      this.viewDetails(id).then(res => {
        this.dialogType = 2
        this.dialogTitle = '编辑'
        this.dialogState = true
      })
    },
    handleDelete(id) {
      this.$confirm('确定删除吗?', '提示', {
        type: 'warning'
      }).then(() => {
        const params = qs.stringify({ id })
        this.axios
          .post('/supplierBaseOverseasWarehouse/delete', params)
          .then(res => {
            if (res.data.code === 200) {
              this.$message.success('成功')
            } else {
              this.$message.error(res.data.message)
            }
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleSizeChange(val) {
      this.page.pageSize = val
      this.page.pageNum = 1
      this.getPage()
    },
    handleCurrentChange(val) {
      this.page.pageNum = val
      this.getPage()
    }
  },
  mounted() {
    this.getCountryList()
    this.getPage()
    this.getCountryList()
  }
}
</script>
<style lang="less" scoped>
  .paging-row{
    text-align: right;
    margin-top: 50px;
    width: 100%;
  }
  .ruleForm{
    /deep/ .el-input{
      width: 207px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/baseData/overseaWarehouseManagement.vue